import * as React from 'react';
import { NavLink as ReactNavLink, NavLinkProps as ReactNavLinkProps } from 'react-router-dom';
import { StyleSheet, css } from 'aphrodite';

interface NavLinkProps extends ReactNavLinkProps {
    notify?: boolean;
    disabled?: boolean;
}

export const NavLink: React.SFC<NavLinkProps> = (props) => {
    const { notify, disabled, children, ...rest } = props;
    return (
        <ReactNavLink
            className={css(styles.nav, notify && styles.navNotifyPseudo, disabled && styles.disabled)}
            activeClassName={css(styles.nav, styles.navActive, notify && styles.navNotifyPseudo)}
            {...rest}
        >
            {children}
        </ReactNavLink>
    );
};

const styles = StyleSheet.create({
    nav: {
        fontFamily: 'Lato',
        fontSize: '16px',
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontStretch: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#222222',
        marginRight: '30px',
        textDecoration: 'none',
        paddingBottom: '5px'
    },
    disabled: {
        pointerEvents: 'none',
        cursos: 'default'
    },
    navActive: {
        fontWeight: 'bold',
        borderBottom: '3px solid #368cd7'
    },
    navNotifyPseudo: {
        ':after': {
            fontFamily: 'Lato',
            color: '#fff',
            content: '\'\\!\'',
            display: 'inline-block',
            position: 'relative',
            top: '-2px',
            right: '-6px',
            width: '16px',
            height: '16px',
            borderRadius: '50%',
            fontSize: '0.75em',
            textAlign: 'center',
            background: '#ff3457',
            animation: '1s bounce 5'
        }
    }
});



// WEBPACK FOOTER //
// ./src/CommonUI/Control/NavLink.tsx